import PostMessageMessage from '../../sdk/types/PostMessageMessage';

const findParentWindow = (): Window | undefined => {
    if (window.parent && window.parent !== window.self) {
        return window.parent;
    }

    if (window.opener) {
        return window.opener;
    }

    return undefined;
};

const postMessageToParent = (message: PostMessageMessage) => {
    const parentWindow = findParentWindow();
    if (!parentWindow) {
        return;
    }

    /**
     * Since we're allowing ANY domain to receive these messages, make sure you
     * don't send anything private over this function.
     */
    parentWindow.postMessage(message, '*');
};

export default postMessageToParent;
